import React, { useState, useEffect } from "react";

import _ from "lodash";
import ReactJson from "react-json-view";
import { Checkbox, Group, Text, TextInput, Select } from "@mantine/core";
import { useForceUpdate } from "@mantine/hooks";
import { useServerApi } from "../hooks/userServerApi";
import useDeepCompareEffect from "../hooks/useDeepCompareEffect";
import ArrayTable from "./arrayTable";
import TemplateSaveLoadButtons from "./templateSaveLoadButtons";

export const defaultOptions = [
  "Age",
  "Annual Turnover",
  "Building Age",
  "Building Construction",
  "Building Type",
  "Business",
  "Business Reg. No.",
  "Chassis No.",
  "Condition",
  "Conveyance",
  "Country of Origin",
  "Coverage",
  "Cylinder Capacity / Tonnage",
  "Driver Age",
  "Driver Id Card No.",
  "Driver Name",
  "Driving Experience",
  "Engine No.",
  "Excess",
  "Floor Area",
  "Geographical",
  "Id / Passport / Business Reg. No.",
  "Id / Passport No.",
  "Indemnity Limit",
  "Insured",
  "Insured Contract",
  "Insured Identity",
  "Insured Vehicle (*)",
  "Insurer",
  "Interest Insured",
  "Make / Model",
  "Mortgage / H.P",
  "Name of Helper",
  "Named Driver (#)",
  "No Claim Discount",
  "No. of Seats (incl. driver)",
  "Occupation",
  "Period",
  "Premium",
  "Premium Rate",
  "Principal",
  "Registration Mark",
  "Relationship",
  "Remark",
  "Retroactive Date",
  "Risk Location",
  "Selected Plan",
  "Settlement Basis",
  "Sum Insured",
  "Type of Body",
  "Voyage",
  "Year of Manufacture",
];

const ParticularList = ({ form: mainForm, name }) => {
  const particulars = _.get(mainForm.values, name) ?? [];
  const forceUpdate = useForceUpdate();
  const [api] = useServerApi();

  const [options, setOptions] = useState(() => {
    // Extract custom labels from existing form data
    const existingLabels = particulars
      .map((p) => p.label)
      .filter((label) => label && !defaultOptions.includes(label));

    // Combine default options with any custom ones
    return [...defaultOptions, ...existingLabels];
  });

  // Update options when particulars change (for async loading)
  useEffect(() => {
    const existingLabels = particulars
      .map((p) => p.label)
      .filter((label) => label && !defaultOptions.includes(label));

    if (existingLabels.length > 0) {
      setOptions((prev) => {
        const newLabels = existingLabels.filter(
          (label) => !prev.includes(label)
        );
        return newLabels.length > 0 ? [...prev, ...newLabels] : prev;
      });
    }
  }, [particulars]);

  const rowInitValue = {
    item: "",
    isKey: false,
    printOnDebitNote: false,
  };

  const fields = [
    {
      header: "Particular",
      headerWidth: "20%",
      fieldName: "label",
      component: Select,
      props: {
        allowFreeInput: true,
        searchable: true,
        clearable: true,
        creatable: true,
        getCreateLabel: (query) => `+ Create ${query}`,
        onCreate: (query) => {
          console.log("onCreate", query);
          setOptions((current) => [...current, query]);
          // mainForm.setFieldValue(name, [...options, query]);
          return query;
        },
        data: options,
      },
    },
    {
      header: "Description (For AI Understanding)",
      headerWidth: "40%",
      fieldName: "description",
      component: TextInput,
    },
    {
      header: "Is Key Particular",
      headerWidth: "10%",
      fieldName: "isKey",
      type: "checkbox",
      component: Checkbox,
      props: {
        type: "checkbox",
      },
    },
    {
      header: "Debit Note",
      headerWidth: "10%",
      fieldName: "printOnDebitNote",
      type: "checkbox",
      component: Checkbox,
      props: {
        type: "checkbox",
      },
    },
  ];

  const onDataChange = (particulars, index, fieldName) => {
    // const d = [...particulars];
    // d.splice(index, 1, data);
    mainForm.setFieldValue(name, particulars ?? []);
  };

  const onRemoveRow = (particulars, index) => {};

  const loadFromTemplate = (template) => {
    mainForm.setFieldValue(name, template.content ?? []);
  };

  return (
    <>
      {/* <ReactJson src={particulars} style={{ background: "white" }} collapsed /> */}
      <TemplateSaveLoadButtons
        form={mainForm}
        name={name}
        templateCategory="Particular List"
        onLoadTemplate={loadFromTemplate}
        currentContent={particulars}
        mb={"sm"}
      />

      <ArrayTable
        form={mainForm}
        name={name}
        rowInitValue={rowInitValue}
        fields={fields}
        onDataChange={onDataChange}
        onRemoveRow={onRemoveRow}
        readonly={false}
      />
    </>
  );
};

export default ParticularList;
